// Svelte / kits
import type { ServerInit } from '@sveltejs/kit';

import { initLiveStream } from '$lib/liveStream/init';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import * as Sentry from '@sentry/browser';

export const init: ServerInit = async () => {
  console.log(`Running in mode ${import.meta.env.MODE}`);

  // Only init Sentry in production
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: 'https://14bb24513e42073d2d1d509b4984a453@o33132.ingest.us.sentry.io/4507766032171008',

      // Alternatively, use `process.env.npm_package_version` for a dynamic release version
      // if your build tool supports it.
      release: `roastlogger-web-svelte@${import.meta.env.PACKAGE_VERSION}`,
      integrations: [
        Sentry.browserTracingIntegration({
          traceXHR: false
        }),
        Sentry.replayIntegration()
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.5,

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: [
        'localhost',
        'http://localhost/api',
        'http://localhost',
        'localhost:5173',
        /^https:\/\/api\.roastlog\.com/,
        /^https:\/\/roastlogger\.online/
      ],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });

    datadogRum.init({
      applicationId: '748ba5e4-6afa-459c-8985-eb0e6a6232c3',
      clientToken: 'pub10899e92fb048918d2dd26cb8bd370cd',
      site: 'datadoghq.com',
      service: 'roastlogger-web-svelte',
      env: import.meta.env.MODE,
      version: import.meta.env.PACKAGE_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      // 'mask-user-input' is the default, but there isn't any sensitive info in here.
      defaultPrivacyLevel: 'allow'
    });
  }
  // End production config

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_TOKEN,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    storeContextsAcrossPages: true,
    service: 'roastlogger-web-svelte',
    env: import.meta.env.MODE,
    version: import.meta.env.PACKAGE_VERSION
  });

  // By default the logs are sent to DDog with the 'http' handler.
  if (import.meta.env.MODE === 'development') {
    console.log('Setting DD logs to console');
    datadogLogs.logger.setHandler('console');
  }

  datadogLogs.setGlobalContextProperty('version', import.meta.env.PACKAGE_VERSION);

  // Initialize the AppSync Events live stream (no-op if env vars are missing)
  initLiveStream();
};
